module.exports = __webpack_public_path__ + "8681f434273fd6a267b1a16a035c5f79.svg";